import React from 'react';
import { CTAButton } from './CTAButton';
import { FadeIn } from './FadeIn';
export function FinalCTA() {
  return <section className="py-12 md:py-32 px-4 bg-gradient-to-br from-kid-purple via-kid-pink to-kid-sky text-white text-center relative overflow-hidden" data-id="element-123">
      <div className="max-w-4xl mx-auto relative z-10 bg-white/10 backdrop-blur-sm p-8 md:p-20 rounded-2xl border border-white/20 shadow-sm" data-id="element-124">
        <FadeIn data-id="element-125">
          <h2 className="text-2xl md:text-5xl font-bold mb-5 md:mb-8 leading-tight" data-id="element-126">
            <span className="block mb-1 md:mb-2 text-white/90" data-id="element-127">
              Empezá hoy mismo.
            </span>
            <span className="block text-white" data-id="element-128">
              Tu hijo merece aprender sin frustración.
            </span>
          </h2>

          <div className="text-sm md:text-lg text-white/90 font-medium mb-6 md:mb-10 leading-relaxed space-y-4 md:space-y-6" data-id="element-129">
            <p className="bg-black/10 py-2 px-4 md:px-6 rounded-lg inline-block border border-white/10" data-id="element-130">
              Accedé al Sistema de Lectura en Orden Correcto™
            </p>

            <p className="mt-4 md:mt-6" data-id="element-131">y acompañá el aprendizaje de tu hijo</p>

            <p className="text-xl md:text-3xl font-bold text-kid-yellow mt-3 md:mt-4" data-id="element-132">
              con un método claro, simple y efectivo.
            </p>
          </div>

          <div className="mt-8 md:mt-12" data-id="element-133">
            <CTAButton text="QUIERO ACCEDER AL SISTEMA »" size="xl" className="w-full sm:w-auto" animatePulse={true} data-id="element-134" />
          </div>

          <div className="mt-4 md:mt-6 inline-flex items-center gap-3 bg-black/10 py-2 px-4 md:px-6 rounded-lg border border-white/10" data-id="element-135">
            <span className="text-white/90 font-medium text-xs md:text-sm" data-id="element-136">
              Acceso inmediato
            </span>
            <span className="text-white/50" data-id="element-137">·</span>
            <span className="text-white/90 font-medium text-xs md:text-sm" data-id="element-138">
              Pago único
            </span>
          </div>
        </FadeIn>
      </div>
    </section>;
}